var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhnMessageClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 2592 2880",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6d920}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2566.5 2031.63V804.48a127.47 127.47 0 0 0-2.44-24.17l-624.44 624.44ZM44.72 737.87a126.55 126.55 0 0 0-19.22 66.61v1379.43l732.63-732.63ZM1478.15 1866.21a215.71 215.71 0 0 1-305.08 0l-352.62-352.62L28 2306.06a127.55 127.55 0 0 0 125.1 103.06h2285.8a127.6 127.6 0 0 0 127.6-127.6v-125.26l-689.2-689.2Z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m851.61 1420.13 31.14 31.15 352.63 352.62a127.59 127.59 0 0 0 180.46 0L1815 1404.75l31.15-31.15 31.16-31.17 638.87-638.87c-21.49-16.49-48.08-26.68-77.27-26.68H153.1c-13.42 0-26.11 2.64-38.26 6.48L820.45 1389Z",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhnMessageClosed);
export default __webpack_public_path__ + "static/media/phnMessageClosed.0d7a2b1fc8313e1c50b084500493a9db.svg";
export { ForwardRef as ReactComponent };